import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { App } from './app/App';
// 英文与数字统一使用 JetBrains Mono。字体随包自托管（不请求 CDN），
// 只声明 unicode-range 子集，浏览器按需下载 latin / latin-ext。
import '@fontsource-variable/jetbrains-mono';
import './styles/index.css';

const container = document.getElementById('root');
if (!container) throw new Error('缺少 #root 容器');

createRoot(container).render(
  <StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </StrictMode>,
);
